import { Package, CalendarDays, CalendarRange, EyeOff } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import type { NewProductsStats } from "@/hooks/useNewProducts";

interface NewProductsStatsProps {
  stats: NewProductsStats | undefined;
  isLoading: boolean;
}

export default function NewProductsStatsComponent({ stats, isLoading }: NewProductsStatsProps) {
  const cards = [
    {
      title: "Totaal Nieuw",
      value: stats?.total ?? 0,
      icon: Package,
      color: "text-blue-600",
      bgColor: "bg-blue-50",
    },
    {
      title: "Vandaag",
      value: stats?.today ?? 0,
      icon: CalendarDays,
      color: "text-green-600",
      bgColor: "bg-green-50",
    },
    {
      title: "Deze Week",
      value: stats?.thisWeek ?? 0,
      icon: CalendarRange,
      color: "text-purple-600",
      bgColor: "bg-purple-50",
    },
    {
      title: "Verborgen",
      value: stats?.hidden ?? 0,
      icon: EyeOff,
      color: "text-gray-600",
      bgColor: "bg-gray-50",
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {cards.map((card) => (
        <Card key={card.title}>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">{card.title}</CardTitle>
            <div className={`p-2 rounded-full ${card.bgColor}`}>
              <card.icon className={`h-4 w-4 ${card.color}`} />
            </div>
          </CardHeader>
          <CardContent>
            {isLoading ? (
              <Skeleton className="h-8 w-16" />
            ) : (
              <div className="text-2xl font-bold">{card.value.toLocaleString("nl-NL")}</div>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
